import { ChevronDown } from "@untitledui/icons";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type PeriodOption = { label: string; days: number };

const PERIOD_OPTIONS: PeriodOption[] = [
  { label: "Last 7 Days", days: 7 },
  { label: "Last 30 Days", days: 30 },
  { label: "Last 90 Days", days: 90 },
];

type SectionDropdownLabelProps = {
  days: number;
  onChange: (days: number) => void;
};

export const SectionDropdownLabel = ({ days, onChange }: SectionDropdownLabelProps) => {
  const current = PERIOD_OPTIONS.find((option) => option.days === days) ?? PERIOD_OPTIONS[1];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-1 shrink-0 outline-none"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="text-sm font-semibold text-tertiary">{current.label}</p>
          <ChevronDown className="size-5 text-tertiary" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuRadioGroup value={String(days)} onValueChange={(value) => onChange(Number(value))}>
          {PERIOD_OPTIONS.map((option) => (
            <DropdownMenuRadioItem key={option.days} value={String(option.days)}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
